/* Cart drawer "Pair Well With": recommendations from up to 3 latest cart products of different families (not only the first), merged round-robin; items already in the cart, other variants of the same product family and sold-out items are dropped; result is cut to the section limit. Falls back to the theme's own request on any error. */
(function () {
  if (window.__bgCartRecMulti) return;
  window.__bgCartRecMulti = true;
  var of = window.fetch;

  function isRec(u) {
    return /\/recommendations\/products/.test(u) && /intent=complementary/.test(u) && /section_id=[^&]*cart-drawer/.test(u);
  }
  function norm(s) {
    return String(s || '').toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim();
  }
  function family(s) {
    return norm(s).split(' ').slice(0, 3).join(' ');
  }
  function keyOf(el) {
    var a = el.querySelector('a[href*="/products/"]');
    return a ? a.getAttribute('href').split('?')[0] : '';
  }
  function titleOf(el) {
    var t = el.querySelector('[class*="card__title"]');
    return t ? t.textContent : '';
  }
  function wrapperOf(doc) {
    return doc.querySelector('cart-drawer-products-recommendation .cart-drawer-products-recommendation__wrapper');
  }

  function multi(u) {
    var url = new URL(u, location.origin);
    var limit = parseInt(url.searchParams.get('limit'), 10) || 3;
    var pid = String(url.searchParams.get('product_id'));
    return of('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      var ids = [pid];
      var inCart = {};
      var fams = {};
      var used = {};
      cart.items.forEach(function (i) {
        if (String(i.product_id) === pid) used[family(i.product_title)] = true;
      });
      cart.items.forEach(function (i) {
        inCart[String(i.url).split('?')[0]] = true;
        var f = family(i.product_title);
        fams[f] = true;
        var id = String(i.product_id);
        if (ids.length < 3 && ids.indexOf(id) < 0 && !used[f] && !/gift/i.test(i.product_title)) {
          ids.push(id);
          used[f] = true;
        }
      });
      return Promise.all(ids.map(function (id) {
        var x = new URL(url.toString());
        x.searchParams.set('product_id', id);
        x.searchParams.set('limit', '8');
        return of(x.toString()).then(function (r) { return r.ok ? r.text() : ''; }).catch(function () { return ''; });
      })).then(function (texts) {
        var docs = texts.map(function (t) { return new DOMParser().parseFromString(t || '<div></div>', 'text/html'); });
        var lists = docs.map(function (d) { var w = wrapperOf(d); return w ? [].slice.call(w.children) : []; });
        var baseIdx = -1;
        docs.forEach(function (d, i) { if (baseIdx < 0 && wrapperOf(d)) baseIdx = i; });
        if (baseIdx < 0) return texts[0] || '';
        var chosen = [];
        var seen = {};
        var max = Math.max.apply(null, lists.map(function (l) { return l.length; }));
        for (var n = 0; n < max && chosen.length < limit; n++) {
          lists.forEach(function (l) {
            var c = l[n];
            if (!c || chosen.length >= limit) return;
            var key = keyOf(c);
            if (!key || seen[key] || inCart[key]) return;
            if (fams[family(titleOf(c))]) return;
            if (/sold out/i.test(c.textContent) || /sold-out/.test(c.innerHTML.slice(0, 4000))) return;
            seen[key] = true;
            chosen.push(c);
          });
        }
        var base = docs[baseIdx];
        var w = wrapperOf(base);
        while (w.firstChild) w.removeChild(w.firstChild);
        chosen.forEach(function (c) { w.appendChild(base.importNode ? base.importNode(c, true) : c); });
        return base.documentElement.outerHTML;
      });
    }).then(function (html) {
      return new Response(html, { status: 200, headers: { 'Content-Type': 'text/html' } });
    });
  }

  window.fetch = function (input, init) {
    var u = typeof input === 'string' ? input : (input && input.url) || '';
    if (!isRec(u)) return of.apply(this, arguments);
    var self = this, args = arguments;
    return multi(u).catch(function () { return of.apply(self, args); });
  };
})();
